import { MemoryStorage } from './storage.memory';
/**
 * Storage type for immutable memory
 * 
 * @export
 * \@class ImmutableMemoryStorage
 * 
 * @author Scott O'Bryan
 * \@since 1.0
 */
export class ImmutableMemoryStorage extends MemoryStorage {
/**
 * Sets a value in memory storage after stringifying the object.  This
 * add some overhead but ensures each copy of the object is immutable.
 * 
 * @param {?} key
 * @param {?} value
 * @return {?}
 */
public set(key: string, value: any): boolean {
        if (value !== undefined) {
            value = JSON.stringify(value);
        }

        return super.set(key, value);
    }
/**
 * Returns an immutable value for the specified key.
 * 
 * @param {?} key
 * @return {?}
 */
public get(key: string): any {
        let /** @type {?} */ value = super.get(key);

        if (value !== undefined) {
            return JSON.parse(value);
        }

        return undefined;
    }
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
